import React, { useState, useEffect } from "react";
import ReactFusioncharts from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Importar FusionCharts y configurar los gráficos con el tema
ReactFusioncharts.fcRoot(FusionCharts, Charts, FusionTheme);

const GraficosInversion = ({ data }) => {
    const [isLoading, setIsLoading] = useState(true); // Indicador de carga

    useEffect(() => {
        if (data) {
            setIsLoading(false); // Desactivar la carga cuando los datos estén listos
        }
    }, [data]);

    // Procesamiento de datos
    const totalProyectos = data.length;
    const proyectosNuevos = data.filter((proyecto) => proyecto.vigenciaInicial >= 2024).length;
    const otrasVigencias = totalProyectos - proyectosNuevos;

    const inversionPorDependencia = data.reduce((acc, proyecto) => {
        acc[proyecto.dependencia] = (acc[proyecto.dependencia] || 0) + proyecto.total;
        return acc;
    }, {});

    const inversionPorMunicipio = data.reduce((acc, proyecto) => {
        proyecto.municipios.forEach((mun) => {
            acc[mun.nomMunicipio] = (acc[mun.nomMunicipio] || 0) + proyecto.total;
        });
        return acc;
    }, {});

    const inversionPorAño = data.reduce((acc, proyecto) => {
        const year = proyecto.vigenciaInicial;
        acc[year] = (acc[year] || 0) + proyecto.total;
        return acc;
    }, {});

    const datosTortaProyectos = [
        { label: "Proyectos Nuevos", value: proyectosNuevos },
        { label: "Otras Vigencias", value: otrasVigencias },
    ];

    const datosBarrasDependencias = Object.keys(inversionPorDependencia).map((dependencia) => ({
        label: dependencia,
        value: inversionPorDependencia[dependencia],
    }));

    {/*Grafico por municipios*/ }
    // Filtramos los proyectos válidos y calculamos inversión directa
    const inversionPorMunicipioDirecta = data.reduce((acc, proyecto) => {
        if (
            proyecto.municipios.length === 1 && // Solo un municipio asociado
            proyecto.municipios[0].codMpio !== "19000" // Excluir "19000"
        ) {
            const municipio = proyecto.municipios[0].nomMunicipio; // Nombre del municipio
            acc[municipio] = (acc[municipio] || 0) + proyecto.total; // Sumamos la inversión
        }
        return acc;
    }, {});

    // Convertimos a un arreglo para el gráfico
    const datosInversionMunicipios = Object.keys(inversionPorMunicipioDirecta).map((municipio) => ({
        label: municipio,
        value: inversionPorMunicipioDirecta[municipio],
    }));

    const datosInversionAños = Object.keys(inversionPorAño).map((año) => ({
        label: año,
        value: inversionPorAño[año],
    }));

    // Configuraciones de gráficos
    const configTorta = {
        type: "pie2d",
        width: "100%",
        height: "400",
        dataFormat: "JSON",
        dataSource: {
            chart: {
                decimals: "1",
                theme: "fusion",
            },
            data: datosTortaProyectos,
        },
    };

    const configBarrasDependencias = {
        type: "column2d",
        width: "100%",
        height: "400",
        dataFormat: "JSON",
        dataSource: {
            chart: {
                xAxisName: "Dependencias",
                yAxisName: "Inversión (COP)",
                numberPrefix: "$",
                theme: "fusion",
            },
            data: datosBarrasDependencias,
        },
    };

    const configBarrasMunicipios = {
        type: "scrollBar2D", // Gráfico con scroll horizontal
        renderAt: "chart-container",
        width: "100%",
        height: "400", // Ajusta la altura del gráfico
        dataFormat: "JSON",
        dataSource: {
            chart: {

                xAxisName: "Municipios",
                yAxisName: "Inversión (COP)",
                numberPrefix: "$",
                theme: "fusion",
                showValues: "1", // Muestra los valores en las barras
                scrollheight: "10", // Altura de la barra de desplazamiento
                flatScrollBars: "1", // Estilo plano del scroll
                scrollShowButtons: "1", // Botones de desplazamiento
                scrollColor: "#cccccc", // Color del scroll
            },
            categories: [
                {
                    category: datosInversionMunicipios.map((municipio) => ({
                        label: municipio.label, // Nombre del municipio
                    })),
                },
            ],
            dataset: [
                {
                    data: datosInversionMunicipios,
                },
            ],
        },
    };





    const configLineAños = {
        type: "line",
        width: "100%",
        height: "400",
        dataFormat: "JSON",
        dataSource: {
            chart: {
                xAxisName: "Años",
                yAxisName: "Inversión",
                numberPrefix: "$",
                theme: "fusion",
            },
            data: datosInversionAños,
        },
    };

    // Renderizar gráficos
    return (
        <div style={{ padding: "20px", backgroundColor: "#f5f5f5" }}>
            {isLoading ? (
                <div style={{ textAlign: "center", padding: "20px" }}>Cargando gráficos...</div>
            ) : (
                <>
                    {/* Proporción de Proyectos */}
                    <div
                        style={{
                            marginBottom: "20px",
                            padding: "20px",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3 style={{ textAlign: "center", marginBottom: "10px", color: "#555" }}>
                            Proporción de proyectos
                        </h3>
                        <ReactFusioncharts {...configTorta} />
                    </div>

                    {/* Inversión por Dependencia */}
                    <div
                        style={{
                            marginBottom: "20px",
                            padding: "20px",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3 style={{ textAlign: "center", marginBottom: "10px", color: "#555" }}>
                            Inversión por dependencia
                        </h3>
                        <ReactFusioncharts {...configBarrasDependencias} />
                    </div>

                    {/* Inversión por Municipio */}
                    <div
                        style={{
                            marginBottom: "20px",
                            padding: "20px",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3 style={{ textAlign: "center", marginBottom: "10px", color: "#555" }}>
                            Inversión por municipio (Directa)
                        </h3>
                        <ReactFusioncharts {...configBarrasMunicipios} />
                    </div>

                    {/* Inversión Total por Año */}
                    <div
                        style={{
                            marginBottom: "20px",
                            padding: "20px",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3 style={{ textAlign: "center", marginBottom: "10px", color: "#555" }}>
                            Inversión total por Vigencia
                        </h3>
                        <ReactFusioncharts {...configLineAños} />
                    </div>
                </>
            )}
        </div>
    );
};

export default GraficosInversion;
